import { map } from 'lodash'
import bus from '@/utils/eventBus'
import moment from 'moment'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM/YYYY')
  },
  setDates (agenda) {
    this.to.schedule_id = null
    this.date = null
    // verificando se agenda não esta null
    if (agenda) {
      this.dates = map(agenda.next_30dates, date => {
        return {
          id: date.date,
          label: this.$moment(date.date).format('DD/MM/YYYY')
        }
      })
    }
  },
  doTransfer () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }
    this.$resource.put(this.schedule.id + '/transfer_to/' + this.to.schedule_id)
      .then(({data}) => {
        // emitindo evento is-transfered para mostrar alert de sucesso.
        bus.$emit('is-transfered', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
      })
  },
  onSelectedDate () {
    this.getTimes = false
    this.to.schedule_id = null
    setTimeout(() => {
      this.getTimes = true
    }, 100)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/transfer/resources/methods.js